/**
 * 利用者が選んだファイルを文字列として読む。
 *
 * `File.text()` は jsdom に無いので、ブラウザ・テスト共通で動く FileReader で読む。
 * 読めない（権限・破損など）ときは reject する。使えるかの判定は呼び出し側が行う。
 */
export function readFileText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error ?? new Error("read failed"));
    reader.readAsText(file);
  });
}

/** 読み取りを差し替えられるようにする（テストで失敗を再現するため）。 */
export type ReadTextDeps = {
  readonly readText: (_file: File) => Promise<string>;
};

export const defaultReadTextDeps: ReadTextDeps = { readText: readFileText };
